import { render } from "./PreventClickResourceTableRow.vue?vue&type=template&id=b50f7f5e"
import script from "./PreventClickResourceTableRow.vue?vue&type=script&lang=js"
export * from "./PreventClickResourceTableRow.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Programs\\Projects\\www\\cae-new-web\\nova\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"PreventClickResourceTableRow.vue"]])

export default __exports__